var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, style: { "background-image": _vm.boxBackground } },
    [
      _c("Observer", {
        on: {
          intersectOn: function($event) {
            _vm.intersected = true
          }
        }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "box__header" }, [
        _c("div", {
          staticClass: "h3 box__heading",
          domProps: { innerHTML: _vm._s(_vm.box.heading) }
        })
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "box__content" },
        [
          _c("div", {
            staticClass: "h3 box__title",
            style: _vm.box.titleColor
              ? "color: " + _vm.box.titleColor + ";"
              : "",
            domProps: { innerHTML: _vm._s(_vm.box.title) }
          }),
          _vm._v(" "),
          _vm.box.type === "gallery" &&
          _vm.box.gallery &&
          _vm.box.gallery.length > 0
            ? _c("div", { staticClass: "box__gallery" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.box.gallery, function(ref, idx) {
                    var image = ref.image
                    var caption = ref.caption
                    return _c(
                      "div",
                      { key: idx, staticClass: "col-12 col-md-4" },
                      [
                        _c("BaseFigure", {
                          scopedSlots: _vm._u(
                            [
                              image
                                ? {
                                    key: "image",
                                    fn: function() {
                                      return [
                                        _c(
                                          "ProgressiveLoader",
                                          _vm._b(
                                            {
                                              attrs: {
                                                observer: false,
                                                triggerLoad: _vm.intersected
                                              }
                                            },
                                            "ProgressiveLoader",
                                            _vm.extractImageData(image),
                                            false
                                          )
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null,
                              {
                                key: "caption",
                                fn: function() {
                                  return [_c("p", [_vm._v(_vm._s(caption))])]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.box.text
            ? _c("div", {
                staticClass: "box__text",
                domProps: { innerHTML: _vm._s(_vm.box.text) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.box.type === "calc"
            ? _c("Calculator", { attrs: { categoryProps: _vm.categoryProps } })
            : _vm._e(),
          _vm._v(" "),
          _vm.showButton(_vm.box.btn) && !_vm.isExternalLink(_vm.box.btn.link)
            ? _c(
                "router-link",
                {
                  staticClass: "btn",
                  attrs: { to: _vm.localizedRoute(_vm.box.btn.link) }
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.$t("Return to shopping")) + "\n\t\t"
                  )
                ]
              )
            : _vm.showButton(_vm.box.btn) &&
              _vm.isExternalLink(_vm.box.btn.link)
            ? _c(
                "a",
                {
                  staticClass: "btn",
                  attrs: { href: _vm.box.btn.link, target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.box.btn.text))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.box.image
        ? _c(
            "section",
            { staticClass: "box__media" },
            [
              _c(
                "ProgressiveLoader",
                _vm._b(
                  {
                    staticClass: "box__image",
                    attrs: { observer: false, triggerLoad: _vm.intersected }
                  },
                  "ProgressiveLoader",
                  _vm.extractImageData(_vm.box.image),
                  false
                )
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("custom")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }